import module from 'viaticos/module.js'

export const schema = {
  fecha: 'date',
  pdf: 'boolean',
  subtotal: 'number',
}

export class ViaticosViaticoNotasvetasService {
  constructor ($http) {
    this.$http = $http
  }

  get (folio) {
    return this.$http.get('api/viaticos/viaticos/viatico/comprobantes', {
      params: {
        folio: folio,
      },
      schema,
    })
  }

  post (folio, xml, pdf, datos) {
    let data = new FormData()
    data.set('pdf', pdf)
    for (let prop in datos) {
      data.set(prop, datos[prop])
    }
    return this.$http.post('api/viaticos/viaticos/viatico/notasventas', data, {
      params: {
        folio: folio,
      },
    })
  }
}

module.service('ViaticosViaticoNotasvetasService', ViaticosViaticoNotasvetasService)



// WEBPACK FOOTER //
// ./src/viaticos/services/Viaticos/Viatico/Notasventas.js